import axios from "axios";
import { CPAgent } from "utils/constants";
import apiEndPoints from "../../utils/apiEndPoints";
import { apiCall } from "../../utils/httpClient";

const editUserProfileUpdate = async (params) => {
  const data = await apiCall("post", apiEndPoints.EDITUSERPROFILE, params, {
    "Content-Type": "application/x-www-form-urlencoded",
  });
  return data;
};
const editAgentProfileUpdate = async (params) => {
  const data = await apiCall("post", apiEndPoints.EDITAGENT, params, {
    "Content-Type": "application/x-www-form-urlencoded",
  });
  return data;
};
const getUserProfile = async (params) => {
  let endPoint =
    params.role_id === CPAgent
      ? apiEndPoints.CHANNELPARTNERDETAIL
      : apiEndPoints.GETUSERPROFILE;
  const data = await apiCall("post", endPoint, params);
  return data;
};

const userProfileService = {
  editUserProfileUpdate,
  getUserProfile,
  editAgentProfileUpdate,
};

export default userProfileService;
